import { z } from 'zod';

export const accountStatusSchema = z.enum(['incomplete', 'manualApproval', 'complete']);

export const bankAccountStatusResponseSchema = z.object({
  isDirectDebitMandateSet: z.boolean(),
  accountStatus: accountStatusSchema,
});
